export default "__VITE_ASSET__b8691c22__"